import React from "react";
import BusinessCard from "./BusinessCard";

const BusinessGrid = ({ businesses, onOpenBusiness }) => {
    if (!businesses.length) {
        return (
            <div className="business-grid-empty">
                <div className="business-grid-empty-icon">+</div>

                <h3>No businesses found</h3>

                <p>Businesses connected to your CA account will appear here.</p>
            </div>
        );
    }

    return (
        <section className="business-grid-section">
            <div className="business-grid-heading">
                <div>
                    <p>Select a business to explore its accounting workspace.</p>
                </div>
            </div>

            <div className="business-grid">
                {businesses.map((business) => (
                    <BusinessCard
                        key      = { business.id }
                        business = { business }
                        onOpen   = { () => onOpenBusiness(business)  }
                    />
                ))}
            </div>
        </section>
    );
};

export default BusinessGrid;
